import scrollfixAtBottom from "../../common/modules/scrollfixAtBottom";
const $ = window.$;

$(document).ready(() => {
  const isTouch = ("ontouchstart" in window);
  if (!isTouch) {
    scrollfixAtBottom({bottom: 10});
  }
});
